<template>
  <div class="top-bar">
    <div class="wrapper">
      <div class="d-flex">
        <slot name="left"> </slot>
      </div>
      <div class="d-flex">
        <slot name="right"> </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "navBar"
};
</script>

<style scoped lang="scss">
.top-bar {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 64px;
  background-color: #09090e;
  max-width: 1248px;
}
.wrapper {
  padding: 10px 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .wrapper {
    padding: 10px 24px;
  }
}
@media (max-width: 575px) {
  .wrapper {
    padding: 10px 15px;
  }
}
</style>
